/**
 * The platform status read (plan `docs/superpowers/plans/2026-10-29-platform-status-banner.md`):
 * an ordinary catalog GET for the Operations screen's Platform status card — Cloudflare incidents
 * on components we use, whether we measurably fail on them, and the customer banner. One read
 * upstream, no write and no queue. The one write here ("Hide banner") is the named exception in
 * `platform-status-writes.ts`, `POST …/dismiss`, a different static segment.
 * Split out of `catalog.ts` on file-size grounds only.
 *
 * The path has no `:param`, so nothing can ride it as an id and `upstream-siblings.ts` needs no row.
 */
import type { ReadRoute } from "./catalog";

export const PLATFORM_STATUS_READ_ROUTES: readonly ReadRoute[] = [
  { path: "/api/admin/platform-status", query: [] },
];
